module.exports = __webpack_public_path__ + "img/wetterspitze.541ec6d6.jpg";